const pillPlus = document.querySelectorAll('.global-allocation-block__pill__plus, .global-allocation-block__pill__minus');
const pills = document.querySelectorAll('.global-allocation-block__pill');
if (pillPlus.length) {
	pillPlus.forEach(singlePillPlus => {
		singlePillPlus.addEventListener('click', () => {
			pills.forEach(singlePill => {
				singlePill.classList.remove('not-active');
				singlePill.classList.remove('is-hovering');
			});

			singlePillPlus.parentElement.parentElement.parentElement.classList.toggle('is-active');
			// add not active to all that are not is-active
			if (document.querySelectorAll('.global-allocation-block__pill.is-active').length) {
				pills.forEach(singlePill => {
					if (!singlePill.classList.contains('is-active')) {
						singlePill.classList.add('not-active');
					}
				});
			}
		});
	});

	pills.forEach(singlePill => {
		singlePill.addEventListener('click', () => {
			const currentPillPlus = singlePill.querySelector('.global-allocation-block__pill__title > .global-allocation-block__pill__heading > .global-allocation-block__pill__plus');
			// trigger click on plus
			currentPillPlus.click();
		});

		singlePill.addEventListener('mouseover', event => {
			// add is-hovering class
			pills.forEach(loopSinglePill => loopSinglePill.classList.remove('is-hovering'));

			if (event.target.classList.contains('global-allocation-block__pill__heading')) {
				event.target.parentElement.parentElement.classList.add('is-hovering');
			} else {
				event.target.classList.add('is-hovering');
			}
		});

		singlePill.addEventListener('mouseleave', () => {
			// remove is-hovering class
			singlePill.classList.remove('is-hovering');
		});
	});
}

const closeAllPills = () => {
	pills.forEach(singlePill => {
		singlePill.classList.remove('is-active');
		singlePill.classList.remove('not-active');
		singlePill.classList.remove('is-hovering');
	});
};

let resizeTimeout = null;

const setPillHeadingOffsets = timeOut => {
	const pillHeadings = document.querySelectorAll('.global-allocation-block__pill__heading:not(.is-copy)');
	const globalAllocationWrapper = document.querySelector('.global-allocation-block');

	if (pillHeadings.length) {
		pillHeadings.forEach(singlePillHeading => {
			singlePillHeading.style.setProperty('top', 'auto', 'important');
			singlePillHeading.style.setProperty('left', 'auto', 'important');
			singlePillHeading.style.setProperty('right', 'auto', 'important');
		});

		clearTimeout(resizeTimeout);

		resizeTimeout = setTimeout(() => {
			pillHeadings.forEach(singlePillHeading => {
				const left = singlePillHeading.getBoundingClientRect().left - globalAllocationWrapper.getBoundingClientRect().left;

				if (window.innerWidth < 1200) {
					const copyHeading = singlePillHeading.nextElementSibling;
					const copyHeadingTop = copyHeading.offsetTop;
					const copyHeadingLeft = copyHeading.getBoundingClientRect().left - globalAllocationWrapper.getBoundingClientRect().left;

					singlePillHeading.style.top = `${ copyHeadingTop }px`;
					singlePillHeading.style.left = `${ copyHeadingLeft }px`;
					singlePillHeading.style.right = `${ copyHeadingLeft }px`;
				} else {
					singlePillHeading.style.top = 'auto';
					singlePillHeading.style.left = `${ left }px`;
					singlePillHeading.style.right = 'auto';
				}
			});
		}, timeOut);
	}
};

setPillHeadingOffsets(200);

window.addEventListener('resize', () => {
	clearTimeout(resizeTimeout);

	closeAllPills();

	setPillHeadingOffsets(400);
});
